import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb602700"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-things mt-md mb-lg" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12 col-3 d-flex align-items-center justify-content-lg-start justify-content-end mb-lg-2" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-9 d-flex align-items-center justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "head" }, "Znajdź usterkę"),
    /*#__PURE__*/_createElementVNode("p", { class: "sub" }, "Nie wiesz co się zepsuło?"),
    /*#__PURE__*/_createElementVNode("p", { class: "sub" }, "Podaj objawy, podpowiemy")
  ])
], -1))
const _hoisted_7 = { class: "row mt-sm" }
const _hoisted_8 = { class: "col-lg-12 col-3 d-flex align-items-center justify-content-lg-start justify-content-end mb-lg-2" }
const _hoisted_9 = { class: "icon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-9 d-flex align-items-center justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "head" }, "Sprawdź koszt"),
    /*#__PURE__*/_createElementVNode("p", { class: "sub" }, [
      /*#__PURE__*/_createTextVNode(" Wiesz co się zepsuło?"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Sprawdź ile to będzie kosztować ")
    ])
  ])
], -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "row mt-sm" }
const _hoisted_13 = { class: "col-lg-12 col-3 d-flex align-items-center justify-content-lg-start justify-content-end mb-lg-2" }
const _hoisted_14 = { class: "icon" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12 col-9 d-flex align-items-center justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "head" }, "Zapytaj eksperta"),
    /*#__PURE__*/_createElementVNode("p", { class: "sub" }, "Pilny problem?"),
    /*#__PURE__*/_createElementVNode("p", { class: "sub" }, "Specjalista pomoże znaleźć rozwiązanie")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_wrench_icon = _resolveComponent("wrench-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_zloty_icon = _resolveComponent("zloty-icon")!
  const _component_phone_icon = _resolveComponent("phone-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: { name: 'find-symptoms' },
        class: "text-decoration-none col-lg-4 col-12"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_wrench_icon, { fill: "white" })
              ])
            ]),
            _hoisted_6
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: {
          name: _ctx.getSelectedCar?.typeId
            ? 'tec-estimate-list'
            : 'tec-estimate-list-no-car',
          params: { typeId: _ctx.getSelectedCar?.typeId },
        },
        class: "text-decoration-none col-lg-4 col-12"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_zloty_icon)
              ])
            ]),
            _hoisted_10
          ])
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("a", {
        href: `tel:${_ctx.getPhoneNumber}`,
        class: "text-decoration-none col-lg-4 col-12"
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_phone_icon)
            ])
          ]),
          _hoisted_15
        ])
      ], 8, _hoisted_11)
    ])
  ]))
}